import { useEffect, useMemo } from 'react';

import { RootState, useAppDispatch } from '@/store/store';
import { useSelector } from 'react-redux';
import { fetchCases } from '@/store/slices/casesSlice';

import { NameCell } from '@/components/Table/Cell/NameCell';
import { ColumnDef } from '@tanstack/react-table';
import Sorting from '@/components/Table/sorting';
import DateCell from '@/components/Table/Cell/DateCell';
import StatusCell from '@/components/Table/Cell/StatusCell';

import { ICases } from '@/pages/cases/types';
import NumberCell from '@/components/Table/Cell/NumberCell';

const useCases = () => {
  const dispatch = useAppDispatch();
  const { data, loading } = useSelector((state: RootState) => state.cases);

  useEffect(() => {
    dispatch(fetchCases());
    // const interval = setInterval(() => {
    //   dispatch(fetchCases());
    // }, 60000);

    // return () => clearInterval(interval);
  }, [dispatch]);

  const columns: ColumnDef<ICases>[] = useMemo(
    () => [
      {
        accessorFn: (row) => row.debtor?.name,
        id: 'debtorName',
        header: ({ column }) => <Sorting header="Skyldner" column={column} />,
        enableSorting: true,
        size: 400,
        cell: ({ row }) => <NameCell name={row?.original?.debtor?.name} />,
      },
      {
        accessorKey: 'dueDate',
        header: ({ column }) => (
          <Sorting header="Forfaldsdato" column={column} />
        ),
        enableSorting: true,
        minSize: 350,
        cell: ({ row }) => <DateCell date={row?.original?.dueDate} />,
      },
      {
        accessorKey: 'amountDue',
        minSize: 250,
        header: ({ column }) => (
          <Sorting header="Tilgodehavende" column={column} />
        ),
        cell: ({ row }) => (
          <NumberCell number={row?.original?.amountDue} />
        ),
      },
      {
        accessorKey: 'status',
        minSize: 250,
        header: 'Status',
        cell: ({ row }) => (
          <StatusCell
            icon={row?.original?.status?.icon}
            title={row?.original?.status?.title}
          />
        ),
      },
    ],
    []
  );

  return {
    data,
    loading,
    columns,
  };
};

export default useCases;
